
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin",
      function () {
        return require("private-next-pages/admin/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin"])
      });
    }
  